<nz-modal [(nzVisible)]="isVisible" nzTitle="Add links"
          (nzOnCancel)="handleCancel()" (nzOnOk)="addLink()" [nzOkDisabled]="!this.linkForm.valid">
  <ng-container *nzModalContent>
    <div [formGroup]="linkForm" nz-form nzLayout="horizontal"> 
      <nz-form-item>
        <nz-form-label [nzSpan]="6" nzRequired>Link Name</nz-form-label>
        <nz-form-control [nzSpan]="18" >
          <input nz-input placeholder="Name" formControlName="name" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="6" nzRequired>Link Url</nz-form-label>
        <nz-form-control [nzSpan]="18" >
          <input nz-input placeholder="URL" formControlName="url" />
        </nz-form-control>
      </nz-form-item>
      
      <nz-form-item>
        <nz-form-label [nzSpan]="6">Link Type</nz-form-label>
        <nz-form-control [nzSpan]="18" nzRequired>
          <nz-select nzPlaceHolder="Select Type" formControlName="type">
            <nz-option nzValue="1" nzLabel="Google Drive"></nz-option>
            <nz-option nzValue="2" nzLabel="Others"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
  </ng-container>
</nz-modal>